import { CustomersState } from './types'

export const initialCustomersState: CustomersState = {
  entries: {},
  pagination: {},
  searchQuery: {},
  totalCount: {},
}
